<template lang="pug">
  ul.coupon-list
    li(v-for="coupon in coupons")
      Coupon(:coupon="coupon" :key="coupon.id")
</template>

<script>
import { mapGetters } from 'vuex';
import { sortBy } from '@/helpers';

import Coupon from './Coupon';

export default {
  name: 'CouponList',
  components: {
    Coupon
  },
  computed: {
    coupons() {
      let coupons = [];
      // get all applicable customer coupons
      // and add applied coupons
      if (this.customer?.coupons?.length) {
        coupons = this.customer.coupons.filter(el => {
          return el.code_required === false && el.applicable === true;
        });
      }

      if (this.checkout.form.coupons?.length) {
        this.checkout.form.coupons.forEach(coupon => {
          if (!coupons.find(el => el.id === coupon.id)) coupons.push(coupon);
        });
      }

      return sortBy(coupons, [
        coupon => (coupon.poition != null ? parseInt(coupon.position) : 0),
        coupon => parseInt(coupon.id)
      ]);
    },
    ...mapGetters({
      checkout: 'shop/checkout',
      customer: 'shop/customer'
    })
  }
};
</script>

<style lang="sass" scoped>
ul.coupon-list
  display: block !important
</style>
